<div class="content">

    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="padding: 10px;">
        <mat-card>
            <div>

                <mat-form-field appearance="outline" style="width:50%">
                    <mat-label>Search Name</mat-label>
                    <input matInput type="text" (keyup)="analyticsFilter($event.target.value)">
                </mat-form-field>
                <div style="float: right;padding:10px;cursor:pointer" mat-raised-button color="blue " class=" " (click)="openDialog() " mat-flat-button><img src="assets/img/icons/group-31.png "></div>
            </div>

            <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8 " style="width: 100%; ">
                <ng-container matColumnDef="analyticsId ">
                    <th mat-header-cell *matHeaderCellDef>Id</th>
                    <td mat-cell *matCellDef="let element ">{{element.analyticsId}}</td>
                </ng-container>

                <ng-container matColumnDef="Sno">
                    <th mat-header-cell *matHeaderCellDef>S.No</th>
                    <td mat-cell *matCellDef="let element ">{{dataSource.filteredData.indexOf(element)+1}}</td>
                </ng-container>


                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>name</th>
                    <td mat-cell *matCellDef="let element">{{element.name}}</td>
                </ng-container>

                <ng-container matColumnDef="powerBIURL">
                    <th mat-header-cell *matHeaderCellDef>power BI URL</th>
                    <td mat-cell *matCellDef="let element">{{element.powerBIURL}}</td>
                </ng-container>

                <!-- <ng-container matColumnDef="type ">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element ">{{element.type}}</td>
            </ng-container>

            <ng-container matColumnDef="entities ">
                <th mat-header-cell *matHeaderCellDef>Entity</th>
                <td mat-cell *matCellDef="let element ">{{element.entities}}</td>
            </ng-container> -->

                <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef>edit</th>
                    <td style="cursor:pointer;" mat-cell *matCellDef="let element" (click)="editAnalytics(element.analyticsId)" >
                        <img src="assets/img/icons/forma-1-copy-2.png ">

                    </td>
                </ng-container>
                <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef>delete</th>
                    <td style="cursor:pointer;" mat-cell *matCellDef="let element;let i=i ndex " (click)="deleteAnalytics(element.analyticsId) ">
                        <img src="assets/img/icons/forma-1.png ">
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedcolumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedcolumns; "></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20] " showFirstLastButtons></mat-paginator>
        </mat-card>
    </div>

</div>